import React from 'react'
import { Container, styled } from '@mui/material'
import { useIsSmallScreen } from '../../core'
import FullScreenLoader from './FullScreenLoader'

const FluidContainer = styled(Container)(({ theme, rootStyles }) => ({
    position: 'absolute',
    ...theme.mixins.headerTop,
    right: 0,
    left: 0,
    bottom: 0,
    padding: 0,
    maxWidth: '100%',
    ...rootStyles,
}))

const XlContainer = styled(Container)({
    padding: 0,
    display: 'flex',
})

const GlobalMenuContainer = styled('div')(({ rootMenuStyles }) => ({
    minWidth: '8rem',
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1200,
    ...rootMenuStyles,
}))

const ContentContainer = styled('div')(
    ({ theme, isSmallScreen, contentContainerStyles }) => ({
        width: '100%',
        ...(!isSmallScreen
            ? {
                  marginLeft: '8rem',
                  paddingRight: '1.6rem',
                  paddingBottom: '2.5rem',
              }
            : {
                  height: '100%',
                  position: 'relative',
                  marginBottom: '2rem',
              }),
        ...contentContainerStyles,
    }),
)

const Layout = ({
    header,
    subHeader,
    globalMenu,
    loading,
    rootMenuStyles,
    rootStyles,
    contentContainerStyles,
    children,
    scrollToTopComponent,
}) => {
    const isSmallScreen = useIsSmallScreen()

    return (
        <FluidContainer
            maxWidth={false}
            rootStyles={rootStyles}
            style={{ padding: '0' }}
        >
            {isSmallScreen && loading && <FullScreenLoader />}

            {header}
            <XlContainer maxWidth="100%" style={{ padding: '0' }}>
                {subHeader && subHeader}

                <GlobalMenuContainer rootMenuStyles={rootMenuStyles}>
                    {globalMenu}
                </GlobalMenuContainer>

                <ContentContainer
                    isSmallScreen={isSmallScreen}
                    contentContainerStyles={contentContainerStyles}
                >
                    {children}
                </ContentContainer>
            </XlContainer>
            {scrollToTopComponent}
        </FluidContainer>
    )
}

export default Layout
